import * as mutationsConstants from './mutations';
import globalConfig from '../../../config/global-config';


const state = () => ({
  // Log/Debug
  sentry: {},
  testLevel: '', // 3 testing levels: `vanguard_only`, `salesforce_only`, `TEST` — _attention à la casse_

  // Configs
  globalConfig,
  affiliateConfig: null,
  journeyConfig: null,
  localConfig: null,

  // User
  locale: 'fr',
  sfId: '',
  customerNumber: '',

  // Already services
  alreadyMap: [],
  alreadyMapInitialized: false,
  alreadyClickedChecked: {},

  // Tracking
  trackingCode: '',
  campaignCode: '',
  externalPartnerId: '',
  leadTrackingCode: '',

  // Parameters
  mbParams: {
    base: '',
    campaignId: '',
    shootId: '',
    segmentId: ''
  },
  marketingCloudParams: {
    marketingCloudDataSourceName: '',
    marketingCloudJobId: '',
    marketingCloudListId: '',
    marketingCloudBatchId: '',
    marketingCloudSendDate: ''
  },

  // Payments
  paymentMethod: '', // "sepa" | "bank_card"
  paymentId: '', // Palyance payment ID
  mandateId: '', // Palyance mandate ID
  recaptureIdentifier: '',
  resubmit: '',
  paymentAccountIdentifier: null, // Palyance payment account identifier (obfuscated)
  doubleOptin: false, // Palyance DoubleOptin flag
  pciToken: null, // Palyance PCI token
  holderName: null, // Palyance holder name
  /**
   * WalletUid
   * This property is setted with a message from the Palyance iFrame (SEPA)
   * This property is sent to Orion
   */
  walletUid: null,
  currentOrderUid: '', // Front-generated order ID
  aspspEmail: null,
  aspspFullAddress: null,
  isAspspPrefillEditedByUser: false,
  isAspspEligible: false,
  aspspEligibleBankCard: false,
  countryExcluded: false,
  aspspEligibleSepa: false,
  aspspPaymentInformations: {
    sepa: null,
    bank_card: null
  },
  fallbackPayment: false,

  // Choices
  choices: [],

  // Contact form
  formIsValid: false,
  useSameAddressForShipping: true,
  formData: {billing: {}, shipping: {}},
  conditionsApproved: false,
  cgsApproved: false,
  prefillData: {},
  prefillDataRaw: {},
  billingCountry: 'FRA',
  shippingCountry: 'FRA',
  isDistinctAddress: false,

  // Orders
  ordersData: [],
  orderDraftSent: false,
  orderComplete: false, // Trigger to send Orion call (complete)
  cancelPreviousOrder: false, // Triggers previous x-sell cancelation
  isPreviousOrderCanceled: false, // True when previous x-sell is actually canceled
  isPreviousOrderExpired: false,

  // Customer journey
  previousExternalOrderId: '',

  coregs: [],

  currentPageId: 0,
  previousPageId: 0,
  has1ClickOptOut: false
});

const getters = {
  // Log/Debug
  testLevel: state => state.testLevel,
  sentry: state => state.sentry,
  countryExcluded: state => state.countryExcluded,

  // Config
  globalConfig: state => state.globalConfig,
  affiliateConfig: state => state.affiliateConfig,
  journeyConfig: state => state.journeyConfig,
  localConfig: state => state.localConfig,

  // User
  locale: state => state.locale,
  sfId: state => state.sfId,
  customerNumber: state => state.customerNumber,

  // Already services
  alreadyMap: state => state.alreadyMap,
  alreadyMapInitialized: state => state.alreadyMapInitialized,
  alreadyClickedChecked: state => state.alreadyClickedChecked,

  // Tracking code
  trackingCode: state => state.trackingCode,
  campaignCode: state => state.campaignCode,
  externalPartnerId: state => state.externalPartnerId,
  leadTrackingCode: state => state.leadTrackingCode,

  // Parameters
  mbParams: state => state.mbParams,
  marketingCloudParams: state => state.marketingCloudParams,

  // Payments
  paymentMethod: state => state.paymentMethod,
  paymentId: state => state.paymentId,
  mandateId: state => state.mandateId,
  recaptureIdentifier: state => state.recaptureIdentifier,
  resubmit: state => state.resubmit,
  paymentAccountIdentifier: state => state.paymentAccountIdentifier,
  pciToken: state => state.pciToken,
  holderName: state => state.holderName,
  doubleOptin: state => state.doubleOptin,
  walletUid: state => state.walletUid,
  currentOrderUid: state => state.currentOrderUid,
  aspspEmail: state => state.aspspEmail,
  aspspFullAddress: state => state.aspspFullAddress,
  isAspspPrefillEditedByUser: state => state.isAspspPrefillEditedByUser,
  isAspspEligible: state => state.isAspspEligible,
  isAspspEligibleBankCard: state => state.aspspEligibleBankCard,
  isAspspEligibleSepa: state => state.aspspEligibleSepa,
  aspspPaymentInformations: state => state.aspspPaymentInformations,
  fallbackPayment: state => state.fallbackPayment,
  showPalyanceBanner: state => {
    if (!state.walletUid && state.sfId) {
      return false;
    }

    if (state.walletUid && state.isAspspEligible) {
      if (state.isAspspPrefillEditedByUser) {
        return false;
      }

      return true;
    }

    return false;
  },

  // Choices
  choices: state => state.choices,

  // Contact form
  formIsValid: state => state.formIsValid,
  useSameAddressForShipping: state => state.useSameAddressForShipping,
  formData: state => state.formData,
  conditionsApproved: state => state.conditionsApproved,
  cgsApproved: state => state.cgsApproved,
  prefillData: state => state.prefillData,
  prefillDataRaw: state => state.prefillDataRaw,
  billingCountry: state => state.billingCountry,
  shippingCountry: state => state.shippingCountry,
  isDistinctAddress: state => state.isDistinctAddress,

  // Order
  ordersData: state => state.ordersData,
  orderDraftSent: state => state.orderDraftSent,
  orderComplete: state => state.orderComplete,
  cancelPreviousOrder: state => state.cancelPreviousOrder,
  isPreviousOrderCanceled: state => state.isPreviousOrderCanceled,
  isPreviousOrderExpired: state => state.isPreviousOrderExpired,

  // Customer journey
  previousExternalOrderId: state => state.previousExternalOrderId,

  coregs: state => state.coregs,

  currentPageId: state => state.currentPageId,
  previousPageId: state => state.previousPageId,
  has1ClickOptOut: state => state.has1ClickOptOut
};

const mutations = {
  // Log/Debug
  [mutationsConstants.SET_TEST_LEVEL](state, data) {
    state.testLevel = data;
  },
  [mutationsConstants.SET_SENTRY](state, data) {
    state.sentry = data;
  },

  // Config
  [mutationsConstants.SET_GLOBAL_CONFIG](state, data) {
    state.globalConfig = data;
  },
  [mutationsConstants.SET_AFFILIATE_CONFIG](state, data) {
    state.affiliateConfig = data;
  },
  [mutationsConstants.SET_JOURNEY_CONFIG](state, data) {
    state.journeyConfig = data;
  },
  [mutationsConstants.SET_LOCAL_CONFIG](state, data) {
    state.localConfig = data;
  },

  // User
  [mutationsConstants.SET_LOCALE](state, data) {
    state.locale = data;
  },
  [mutationsConstants.SET_SF_ID](state, data) {
    state.sfId = data;
  },
  [mutationsConstants.SET_CUSTOMER_NUMBER](state, data) {
    state.customerNumber = data;
  },

  // Already services
  [mutationsConstants.SET_USER_ALREADY_MAP](state, data) {
    state.alreadyMap = data;
  },
  [mutationsConstants.SET_USER_ALREADY_INITIALIZED](state, data) {
    state.alreadyMapInitialized = data;
  },
  [mutationsConstants.SET_ALREADY_CLICKED_CHECKED](state, data) {
    state.alreadyClickedChecked = data;
  },

  // Tracking
  [mutationsConstants.SET_TRACKING_CODE](state, data) {
    state.trackingCode = data;
  },
  [mutationsConstants.SET_CAMPAIGN_CODE](state, data) {
    state.campaignCode = data;
  },
  [mutationsConstants.SET_EXTERNAL_PARTNER_ID](state, data) {
    state.externalPartnerId = data;
  },
  [mutationsConstants.SET_LEAD_TRACKING_CODE](state, data) {
    state.leadTrackingCode = data;
  },

  // Parameters
  [mutationsConstants.SET_MB_PARAMS](state, data) {
    state.mbParams = data;
  },
  [mutationsConstants.SET_MARKETING_CLOUD_PARAMS](state, data) {
    state.marketingCloudParams = data;
  },

  // Payments
  [mutationsConstants.SET_PAYMENT_METHOD](state, data) {
    state.paymentMethod = data;
  },
  [mutationsConstants.SET_PAYMENT_ID](state, data) {
    state.paymentId = data;
  },
  [mutationsConstants.SET_MANDATE_ID](state, data) {
    state.mandateId = data;
  },
  [mutationsConstants.SET_RECAPTURE_IDENTIFIER](state, data) {
    state.recaptureIdentifier = data;
  },
  [mutationsConstants.SET_RESUBMIT](state, data) {
    state.resubmit = data;
  },
  [mutationsConstants.SET_PAYMENT_ACCOUNT_IDENTIFIER](state, data) {
    state.paymentAccountIdentifier = data;
  },
  [mutationsConstants.SET_PCI_TOKEN](state, data) {
    state.pciToken = data;
  },
  [mutationsConstants.SET_HOLDER_NAME](state, data) {
    state.holderName = data;
  },
  [mutationsConstants.SET_DOUBLE_OPTIN](state, data) {
    state.doubleOptin = data;
  },
  [mutationsConstants.SET_COUNTRIEXCLUDED](state, data) {
    state.countryExcluded = data;
  },
  [mutationsConstants.SET_PAYMENT_WALLET_UID](state, data) {
    state.walletUid = data;
  },
  [mutationsConstants.SET_CURRENT_ORDER_UID](state, data) {
    state.currentOrderUid = data;
  },
  [mutationsConstants.SET_ASPSP_EMAIL](state, data) {
    state.aspspEmail = data;
  },
  [mutationsConstants.SET_ASPSP_FULL_ADDRESS](state, data) {
    state.aspspFullAddress = data;
  },
  [mutationsConstants.SET_IS_ASPSP_PREFILL_EDITED_BY_USER](state, data) {
    state.isAspspPrefillEditedByUser = data;
  },
  [mutationsConstants.SET_IS_ASPSP_ELIGIBLE](state, data) {
    state.isAspspEligible = data;
  },
  [mutationsConstants.SET_IS_ASPSP_ELIGIBLE_BANK_CARD](state, data) {
    state.aspspEligibleBankCard = data;
  },
  [mutationsConstants.SET_IS_ASPSP_ELIGIBLE_SEPA](state, data) {
    state.aspspEligibleSepa = data;
  },
  [mutationsConstants.SET_ASPSP_PAYMENT_INFORMATIONS](state, data) {
    state.aspspPaymentInformations = data;
  },

  // Choices
  [mutationsConstants.SET_CHOICES](state, data) {
    state.choices = data;
  },

  // Contact form
  [mutationsConstants.SET_FORM_IS_VALID](state, data) {
    state.formIsValid = data;
  },
  [mutationsConstants.SET_USE_SAME_ADDRESS_FOR_SHIPPING](state, data) {
    state.useSameAddressForShipping = data;
  },
  [mutationsConstants.SET_FORM_DATA](state, data) {
    state.formData = data;
  },
  [mutationsConstants.SET_CONDITIONS_APPROVED](state, data) {
    state.conditionsApproved = data;
  },
  [mutationsConstants.SET_CGS_APPROVED](state, data) {
    state.cgsApproved = data;
  },
  [mutationsConstants.SET_PREFILL_DATA](state, data) {
    state.prefillData = data;
  },
  [mutationsConstants.SET_PREFILL_DATA_RAW](state, data) {
    state.prefillDataRaw = data;
  },
  [mutationsConstants.SET_BILLING_COUNTRY](state, data) {
    state.billingCountry = data;
  },
  [mutationsConstants.SET_SHIPPING_COUNTRY](state, data) {
    state.shippingCountry = data;
  },
  [mutationsConstants.SET_ISDISTINCT_ADRESS](state, data) {
    state.isDistinctAddress = data;
  },

  // Order
  [mutationsConstants.SET_ORDERS_DATA](state, data) {
    state.ordersData = data;
  },
  [mutationsConstants.SET_ORDER_DRAFT_SENT](state, data) {
    state.orderDraftSent = data;
  },
  [mutationsConstants.SET_ORDER_COMPLETE](state, data) {
    state.orderComplete = data;
  },
  [mutationsConstants.SET_CANCEL_PREVIOUS_ORDER](state, data) {
    state.cancelPreviousOrder = data;
  },
  [mutationsConstants.SET_IS_PREVIOUS_ORDER_CANCELLED](state, data) {
    state.isPreviousOrderCanceled = data;
  },
  [mutationsConstants.SET_IS_PREVIOUS_ORDER_EXPIRED](state, data) {
    state.isPreviousOrderExpired = data;
  },
  [mutationsConstants.HAS_1_CLICK_OPT_OUT](state, data) {
    state.has1ClickOptOut = data;
  },

  // Customer journey
  [mutationsConstants.SET_PREVIOUS_EXTERNAL_ORDER_ID](state, data) {
    state.previousExternalOrderId = data;
  },

  [mutationsConstants.SET_COREGS](state, data) {
    state.coregs = data;
  },

  [mutationsConstants.SET_CURRENT_PAGE_ID](state, data) {
    state.currentPageId = data;
  },
  [mutationsConstants.SET_PREVIOUS_PAGE_ID](state, data) {
    state.previousPageId = data;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/common/store/store.js